"use strict";

var _classCallCheck = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IJsonRpcProvider = exports.IBaseJsonRpcProvider = exports.IJsonRpcConnection = void 0;

var misc_1 = require("./misc");

var IJsonRpcConnection = /*#__PURE__*/function (_misc_1$IEvents) {
  _inherits(IJsonRpcConnection, _misc_1$IEvents);

  function IJsonRpcConnection(opts) {
    _classCallCheck(this, IJsonRpcConnection);

    return _possibleConstructorReturn(this, _getPrototypeOf(IJsonRpcConnection).call(this));
  }

  return IJsonRpcConnection;
}(misc_1.IEvents);

exports.IJsonRpcConnection = IJsonRpcConnection;

var IBaseJsonRpcProvider = /*#__PURE__*/function (_misc_1$IEvents2) {
  _inherits(IBaseJsonRpcProvider, _misc_1$IEvents2);

  function IBaseJsonRpcProvider() {
    _classCallCheck(this, IBaseJsonRpcProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(IBaseJsonRpcProvider).call(this));
  }

  return IBaseJsonRpcProvider;
}(misc_1.IEvents);

exports.IBaseJsonRpcProvider = IBaseJsonRpcProvider;

var IJsonRpcProvider = /*#__PURE__*/function (_IBaseJsonRpcProvider) {
  _inherits(IJsonRpcProvider, _IBaseJsonRpcProvider);

  function IJsonRpcProvider(connection) {
    _classCallCheck(this, IJsonRpcProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(IJsonRpcProvider).call(this));
  }

  return IJsonRpcProvider;
}(IBaseJsonRpcProvider);

exports.IJsonRpcProvider = IJsonRpcProvider;